function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M292.09 233.37L292.09 233.74L292.09 233.95L292.09 233.58L292.09 233.95L292.09 233.74L292.09 233.37L292.09 233L292.09 232.79L292.09 233.16L292.09 232.79L292.09 233L292.09 233.37Z",
  id: "k3lmlrvVef"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.84 270L422.33 354.23L375.58 401.4L292.09 317.17L208.61 401.4L161.86 354.23L245.34 270L161.86 185.77L208.61 138.6L292.09 222.83L375.58 138.6L422.33 185.77L338.84 270Z",
  id: "ffjZwdCG9"
}), /*#__PURE__*/React.createElement("mask", {
  id: "maskd2KSTPxFtj",
  x: 161.86,
  y: 138.6,
  width: 260.47,
  height: 262.79,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("rect", {
  x: 161.86,
  y: 138.6,
  width: 260.47,
  height: 262.79,
  fill: "white"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ffjZwdCG9",
  opacity: 0.91,
  fill: "black"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k3lmlrvVef",
  opacity: 1,
  fill: "#773825",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ffjZwdCG9",
  opacity: 0.91,
  fill: "white",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#maskd2KSTPxFtj)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ffjZwdCG9",
  opacity: 0.91,
  fillOpacity: 0,
  strokeWidth: 0,
  strokeOpacity: 1
})))));

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 600 550",
    width: 240,
    height: 240,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x.7d0c267b.svg";
export { ForwardRef as ReactComponent };